const getBase64 = (file: File, callback: (result: any) => void) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => callback(reader.result);
};

export default getBase64;
